(() => {
  'use strict';
  const safeUrl = (value, origin) => {
    try {
      const url = new URL(value, origin);
      return url.protocol === 'https:' && !url.username && !url.password && !url.hash && (url.origin === origin || url.hostname === 'cdn.shopify.com') ? url.href : null;
    } catch (_) { return null; }
  };
  const validGroup = group => group && typeof group.title === 'string' && Array.isArray(group.items) && group.items.length > 1 && group.items.length <= 30;
  if (typeof module !== 'undefined' && module.exports) { module.exports = { safeUrl, validGroup }; return; }
  if (typeof document === 'undefined') return;
  const bind = root => {
    if (root.dataset.spaceSelectionBound) return;
    root.dataset.spaceSelectionBound = 'true';
    let manifestPromise;
    let requestId = 0;
    const load = () => {
      if (!manifestPromise) manifestPromise = (async () => {
        const url = safeUrl(root.dataset.spaceSelectionUrl, location.origin);
        if (!url) throw new Error('url');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('response');
        const data = await response.json();
        if (data.version !== 1 || !data.groups) throw new Error('data');
        return data.groups;
      })().catch(error => { manifestPromise = null; throw error; });
      return manifestPromise;
    };
    const flowerReady = async () => {
      const current = document.querySelector('ace-category-flower');
      if (current?.ready && typeof current.openSelection === 'function') return current;
      return new Promise((resolve, reject) => {
        const finish = (flower, error) => {
          clearTimeout(timer);
          document.removeEventListener('ace:flower-ready', ready);
          error ? reject(error) : resolve(flower);
        };
        const ready = event => {
          if (event.target?.matches?.('ace-category-flower') && typeof event.target.openSelection === 'function') finish(event.target);
        };
        const timer = setTimeout(() => finish(null, new Error('timeout')), 12000);
        document.addEventListener('ace:flower-ready', ready);
      });
    };
    root.addEventListener('click', async event => {
      const trigger = event.target.closest('a[data-space-selection]');
      if (!trigger || !root.contains(trigger) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const token = ++requestId;
      trigger.setAttribute('aria-busy', 'true');
      try {
        const [groups, flower] = await Promise.all([load(), flowerReady()]);
        if (token !== requestId || !trigger.isConnected) return;
        const key = trigger.dataset.spaceSelection;
        const group = groups[key];
        if (!/^[a-z][a-z0-9_-]{0,63}$/.test(key) || !validGroup(group)) throw new Error('group');
        if (window.AceBoard?.ready) await window.AceBoard.ready;
        const items = typeof window.AceProductDestination?.verifyPublished === 'function' ? await window.AceProductDestination.verifyPublished(group.items) : group.items;
        if (token !== requestId || !trigger.isConnected) return;
        document.dispatchEvent(new CustomEvent('ace:catalog-items', { detail: { items } }));
        if (!flower.openSelection({ key: `scene-${key}`, title: group.title, description: group.description, centerSku: group.centerSku, items }, trigger)) throw new Error('open');
      } catch (_) {
        if (token === requestId && trigger.isConnected && !document.querySelector('dialog[open]')) location.assign(trigger.href);
      } finally {
        trigger.removeAttribute('aria-busy');
      }
    });
    root.addEventListener('pointerover', () => { load().catch(() => {}); }, { once: true });
    root.addEventListener('focusin', () => { load().catch(() => {}); }, { once: true });
  };
  const start = (scope = document) => {
    if (scope.matches?.('[data-space-selection-root]')) bind(scope);
    scope.querySelectorAll('[data-space-selection-root]').forEach(bind);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true }); else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();

